import UseToast from 'hooks/use-toast';

import LectureMainButton from 'components/pages/lecture/lecturemainbutton/LectureMainButton';
import CourseMainButton from 'components/pages/course/coursemainbutton/CourseMainButton';
import ContentPrice from 'components/common/contentprice/ContentPrice';
import ContentCategoryChip from '../contentcategorychip/ContentCategoryChip';
import ActionButton from '@core/components/actionbutton/ActionButton';

import { copyTextToClipboard } from 'utils/clipboard';
import { Lacking } from 'constants/content-status';

import { Share, Book1, Ranking } from 'iconsax-react';

import LanguageIcon from 'assets/icons/autobrightness-icon-yellow.svg';
import MobileIcon from 'assets/icons/mobile-icon-yellow.svg';
import CertificateIcon from 'assets/icons/teacher-icon-yellow.svg';
import VIPIcon from 'assets/icons/vip-card-icon.svg';
import RankingIcon from 'assets/icons/ranking.svg';
import AwardIcon from 'assets/icons/award.svg';
import WifiIcon from 'assets/icons/wifi-square.svg';
import ShareIcon from 'assets/icons/share.svg';

import classes from './ContentStickySide.module.scss';
import Link from 'next/link';
import FinancialAid from '@core/components/financialaid/FinancialAid';

const ContentStickySide = ({ data, refetchOverview, contentType = 'course' }) => {
	const { ToastContainer, toast } = UseToast();
	const onShareHandler = () => {
		copyTextToClipboard(window.location.href);
		toast('Link copied to clipboard');
	};
	return (
		<>
			<div className={`${classes['content-sticky-side-wrapper']} d-flex flex-column gap-2`}>
				<h5 className="d-flex align-items-center gap-2">
					{data.has_vip_access && <VIPIcon />} {data.title}
				</h5>
				{!data.last_updated_date ? (
					<p>Released on {data?.release_date}</p>
				) : (
					<p>Last update on {data?.last_updated_date}</p>
				)}
				<div className="d-none d-xl-flex flex-row flex-wrap gap-2">
					{/* {data.categories.map((category) => (
						<ContentCategoryChip key={category.id || category.name} {...category} />
					))} */}
				</div>
				<div>
					<ul className="d-flex flex-column gap-3 my-3">
						{data.lecture_count && (
							<li>
								<Book1 color="#faa61a" /> {data.lecture_count} Courses
							</li>
						)}
						{!!data.proficiency && (
							<li className='text-capitalize'>
								<RankingIcon /> {data.proficiency}
							</li>
						)}
						<li>
							<Link href={'/pharmuni-certificate'} rel="noopener noreferrer" target="_blank" className='text-dark'>
								<AwardIcon /> + Certificate
							</Link>
						</li>
						{/* <li>
							<LanguageIcon /> {data.languages.map((lng) => lng.name).join(',')}
						</li> */}
						<li>
							<MobileIcon /> Available on app
						</li>
						<li>
							<WifiIcon /> Online at your own pace
						</li>
						<li>
							<ShareIcon /> Shareable certificate of completion
						</li>

					</ul>
				</div>
				{data?.status === Lacking && (
					<ContentPrice
						className="my-1"
						price={data?.price}
						payable_price={data?.payable_price}
						promotion_percentage={data?.promotion_percentage}
						is_free={data?.is_free}
						discounted_price={data?.discounted_price}
						currency={data?.currency}
					/>
				)}
				{data.status === 'coming_soon' && (
					<span className={`${classes['action-status-detail-coming-soon-badge']}`}>
						Coming Soon
					</span>
				)}
				{contentType === 'course' ? (
					<LectureMainButton
						lecture_id={data?.id}
						status={data?.status}
						price={data?.price}
						refetchOverview={refetchOverview}
						kind="secondary"
						unlock_in={data?.unlock_in}
					/>
				) : (
					<CourseMainButton
						course_id={data?.id}
						status={data?.status}
						price={data?.price}
						refetchOverview={refetchOverview}
						kind="secondary"
					/>
				)}
				<div className='d-flex  justify-content-between align-items-center'>

					<ActionButton
						onClick={onShareHandler}
						kind="blank"
						className="d-flex align-items-center gap-1">
						<Share size="18" color="#bb3a90" /> Share
					</ActionButton>
					<FinancialAid isBanner={false} />
				</div>

			</div>
			<ToastContainer />
		</>
	);
};

export default ContentStickySide;
